import { RootDeviceTypeRoute, RootDeviceTypeLink, RootDeviceTypeItemRoute, RootDeviceTypeItemInfoRoute, RootDeviceTypeItemInfoLink } from "./rootDeviceType/index.js";
import { RootDeviceGroupRoute, RootDeviceGroupLink, RootDeviceGroupItemRoute, RootDeviceGroupItemInfoRoute, RootDeviceGroupItemInfoLink } from "./rootDeviceGroup/index.js";
import { RootFirmwareReleaseItemInfoLink, RootFirmwareReleaseItemInfoRoute, RootFirmwareReleaseItemRoute, RootFirmwareReleaseLink, RootFirmwareReleaseRoute } from "./rootFirmwareRelease/index.js";
import { RootFirmwareApplicationItemInfoLink, RootFirmwareApplicationItemInfoRoute, RootFirmwareApplicationItemRoute, RootFirmwareApplicationLink, RootFirmwareApplicationRoute } from "./rootFirmwareApplication/index.js";
import { RootFirmwareComponentItemInfoLink, RootFirmwareComponentItemInfoRoute, RootFirmwareComponentItemRoute, RootFirmwareComponentLink, RootFirmwareComponentRoute } from "./rootFirmwareComponent/index.js";
import { RootDeviceRoute, RootDeviceLink, RootDeviceItemInfoRoute, RootDeviceItemRoute, RootDeviceItemInfoLink } from "./rootDevice/index.js";
function install(molten) {
  molten.addPlugin('Route', RootDeviceTypeRoute);
  molten.addPlugin('Action', RootDeviceTypeLink);
  molten.addPlugin('Route', RootDeviceTypeItemRoute);
  molten.addPlugin('Route', RootDeviceTypeItemInfoRoute);
  molten.addPlugin('Action', RootDeviceTypeItemInfoLink);
  molten.addPlugin('Route', RootDeviceGroupRoute);
  molten.addPlugin('Action', RootDeviceGroupLink);
  molten.addPlugin('Route', RootDeviceGroupItemRoute);
  molten.addPlugin('Route', RootDeviceGroupItemInfoRoute);
  molten.addPlugin('Action', RootDeviceGroupItemInfoLink);
  molten.addPlugin('Route', RootFirmwareReleaseRoute);
  molten.addPlugin('Action', RootFirmwareReleaseLink);
  molten.addPlugin('Route', RootFirmwareReleaseItemRoute);
  molten.addPlugin('Route', RootFirmwareReleaseItemInfoRoute);
  molten.addPlugin('Action', RootFirmwareReleaseItemInfoLink);
  molten.addPlugin('Route', RootFirmwareApplicationRoute);
  molten.addPlugin('Action', RootFirmwareApplicationLink);
  molten.addPlugin('Route', RootFirmwareApplicationItemRoute);
  molten.addPlugin('Route', RootFirmwareApplicationItemInfoRoute);
  molten.addPlugin('Action', RootFirmwareApplicationItemInfoLink);
  molten.addPlugin('Route', RootFirmwareComponentRoute);
  molten.addPlugin('Action', RootFirmwareComponentLink);
  molten.addPlugin('Route', RootFirmwareComponentItemRoute);
  molten.addPlugin('Route', RootFirmwareComponentItemInfoRoute);
  molten.addPlugin('Action', RootFirmwareComponentItemInfoLink);
  molten.addPlugin('Route', RootDeviceRoute);
  molten.addPlugin('Action', RootDeviceLink);
  molten.addPlugin('Route', RootDeviceItemRoute);
  molten.addPlugin('Route', RootDeviceItemInfoRoute);
  molten.addPlugin('Action', RootDeviceItemInfoLink);
}
export { install };
export default {
  install
};